/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{legacyIcon as t}from"../support/legacyIcon.js";const o="esri-navigation-toggle",n={base:o,widgetIcon:t.pan2,button:`${o}__button`,activeButton:`${o}__button--active`,panButton:`${o}__button--pan`,rotateButton:`${o}__button--rotate`,isLayoutHorizontal:`${o}--horizontal`};export{n as css};
